import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalServices } from '../global.services';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {
  registerForm: FormGroup;
  submitted: boolean = false;
  contRes: boolean = false;
  showAlert = false;
  responseMessage = '';
  uploadFileName: string = '';
  @ViewChild('careerFile', { static: true }) careerFile: ElementRef;
  constructor(private formBuilder: FormBuilder, private globalService: GlobalServices, private httpService: ApiService) { }
  ngOnInit() {
    if(this.globalService?.isBrowser){
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
      this.globalService.createTabs();
      this.registerForm = this.formBuilder.group({
        name: ["", Validators.required],
        mobile: ["", Validators.required],
        email: ["", [Validators.required, Validators.email,
          this.emailDomainValidator]],
        position: [""],
        resume: ["", Validators.required],
        about: [""]
      });
    }
  }
  //emial custom validation function
  emailDomainValidator(control: FormControl) {
    let email = control.value;
    if (email && email.indexOf("@") != -1) {
      let [_, domain] = email.split("@");
      if (domain.length < 5) {
        return {
          emailDomain: {
            parsedDomain: domain
          }
        }
      } else {
        if (domain && domain.indexOf(".") != -1) {
          let [before, after] = domain.split(".");
          if (before.length < 2) {
            return {
              emailDomain: {
                parsedDomain: domain
              }
            }
          } else if (after.length < 2) {
            return {
              emailDomain: {
                parsedDomain: domain
              }
            }
          } else {
            return null;
          }
        } else {
          return {
            emailDomain: {
              parsedDomain: domain
            }
          }
        }
      }
    }
    return null;
  }
  // Image Upload
  getFile(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      let allowed_extensions = new Array("jpg", "png", "jpeg", "JPEG", "JPG", "PNG");
      let file_extension = event.target.files[0]['name'].split('.').pop();
      if (allowed_extensions.indexOf(file_extension) >= 0) {
        alert("File Not allowed");
        return;
      }
      reader.readAsDataURL(event.target.files[0]);
      // save Data to API********************************************************
      if (event.target.files[0]) {
        this.uploadFileName = event.target.files[0]['name'];
        this.registerForm.controls['resume'].setValue(event.target.files[0]);
      }
    }
  }

  get formData() {
    return this.registerForm.controls;
  }

  toFormData<T>(formValue: T) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    else {
      let URL = "global/career";
      let data = this.registerForm.value;
      this.httpService.postFormData(URL, this.toFormData(data)).subscribe(response => {
        this.submitted = false;
        this.uploadFileName = "";
        this.registerForm.reset();
        this.careerFile.nativeElement.value = "";
        if (response.success) {
          if (this.globalService.isBrowser) {
            this.showAlert = true;
            this.responseMessage = 'Your Form has been submitted successfully';
            setTimeout(() => {
              this.contRes = false;
              this.showAlert = false;
            }, 3000);
          }
        }
      });
    }
  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }
}
